import { createSelector } from 'reselect';

const playerSelector = (state) => state.player;

export const audioRecordSelector = createSelector(playerSelector, (player) => player.record);
export const audioLoadingSelector = createSelector(playerSelector, (player) => player.isAudioLoading);
export const playerDataSelector = createSelector(playerSelector, (player) => player.player);
export const mp3DataSelector = createSelector(playerSelector, (player) => player.mp3Data);
export const mp3LoadingSelector = createSelector(playerSelector, (player) => player.isMP3Loading);
